import React from "react";
import { Clock } from "lucide-react";
import "./IntroIntakeNotice.scss";

export const intakeBlocked = (intake) => !!intake && intake.canSend === false;

const IntroIntakeNotice = ({ intake }) => {
  if (!intakeBlocked(intake)) return null;
  return (
    <div className="intro-intake-notice" role="status">
      <Clock size={18} aria-hidden="true" />
      <p>{intake.message}</p>
    </div>
  );
};

export default IntroIntakeNotice;
